<template>
  <div id="app">
  <router-view />
 </div>
</template>
<script></script>
<style>
  .text-site-orange{
    color: #ffa020;
  }
  .bg-site-orange{
    color: #ffa020;
  }
  .bg-site-green{
    color: var(--brand-primary);
  }

  .badge-color-yellow{
    background-color: #ffa020;
  }
  
  
  

  .alert-custom-green {
    background-color: var(--brand-primary) !important; 
    color: white !important;
  }

  .modal-header-custom {
    background-color: var(--brand-primary) !important;
    color: white !important;
  }
</style>
